'use strict';

import angular from 'angular';
import routes from './admin.routes';
import GroupAdminController from './groupAdmin/groupAdmin.controller';
import GroupAdminService from './groupAdmin/groupAdmin.service';
import ManagerController from './manager/manager.controller';
import ManagerService from './manager/manager.service';
import UserModificationModalController from '../../components/user-modification-modal/user-modification-modal.controller';

export default angular.module('safestartServerApp.admin', ['safestartServerApp.auth', 'ui.router'])
  .config(routes)
  .factory('Group', GroupAdminService)
  .factory('ManageGroup', ManagerService)
  .controller('UserModificationModalController', UserModificationModalController)
  .controller('GroupAdminController', GroupAdminController)
  .controller('ManagerController', ManagerController)
  .name;



// WEBPACK FOOTER //
// ./client/app/admin/index.js